import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type CmeEventRequestBody = Static<typeof CmeEventRequestBodySchema>;

export const CmeEventRequestBodySchema = Type.Object(
  {
    message: Type.Object(
      {
        attributes: Type.Optional(Type.Record(Type.String(), Type.String())),
        messageId: Type.String(),
        publishTime: Type.String(),
        // Data is base 64 encoded
        data: Type.String(),
      },
      { additionalProperties: true }
    ),
    subscription: Type.String(),
  },
  { additionalProperties: true, $id: 'CmeEventSchema' }
);

export const BounceTypeSchema = Type.Literal('bounce');
export const ClickTypeSchema = Type.Literal('click');
export const ComplaintTypeSchema = Type.Literal('complaint');
export const DeliveryTypeSchema = Type.Literal('delivery');
export const InitialOpenTypeSchema = Type.Literal('initial_open');
export const OpenTypeSchema = Type.Literal('open');
export const SentTypeSchema = Type.Literal('injection');

export type CmeEventType = Static<typeof CmeEventTypeSchema>;

export const CmeEventTypeSchema = Type.Union([
  BounceTypeSchema,
  ClickTypeSchema,
  ComplaintTypeSchema,
  DeliveryTypeSchema,
  InitialOpenTypeSchema,
  OpenTypeSchema,
  SentTypeSchema,
]);

export type CmeEventData = Static<typeof CmeEventDataSchema>;

export const CmeEventDataSchema = Type.Object(
  {
    eventData: Type.Object(
      {
        type: CmeEventTypeSchema,
        rcpt_meta: Type.Object(
          {
            messageRequestIds: Type.Array(Type.String({ format: 'uuid' })),
          },
          { additionalProperties: true }
        ),
      },
      { additionalProperties: true }
    ),
    customerMessageInfo: Type.Object(
      {
        market: Type.String({ maxLength: 2, minLength: 2 }),
        testSend: Type.Boolean(),
      },
      { additionalProperties: true }
    ),
  },
  { additionalProperties: true, $id: 'CmeEventData' }
);
